import { HttpContextToken } from '@angular/common/http';

/**
 * Unterdrückt die generischen Fehler-Toasts des {@link AuthorizationInterceptor} für einen
 * einzelnen Request. Gedacht für Massenverarbeitungen, bei denen pro fehlgeschlagenem Request
 * ein Toast erscheinen würde (z. B. Workflow-Regel Massenausführung) und der Aufrufer die Fehler
 * stattdessen selbst pro Datensatz protokolliert.
 *
 * Der 401-Zweig (Session abgelaufen -> Logout) bleibt bewusst unberührt.
 *
 * Hinweis: `HttpService.skipErrorHandler()` erfüllt diesen Zweck **nicht** — der dafür nötige
 * Token `HTTP_DYNAMIC_INTERCEPTORS` (`core/http/http.service.ts`) wird nirgends bereitgestellt,
 * die Liste ist immer leer und `removeInterceptor()` damit wirkungslos.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
